import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const searchInviteNeighbors = createAsyncThunk(
    "neighborInviteSearch/search",
    async ({ q = "", page = 1, page_size = 10 } = {}, { rejectWithValue }) => {
        try {
            const params = { page, page_size };
            if (q.trim()) params.q = q.trim();
            const response = await axiosInstance.get("/neighbor_news/search_invite_neighbors/", { params });
            return { data: response.data, page };
        } catch (error) {
            if (error.response) return rejectWithValue(error.response.data);
            if (error.request) return rejectWithValue("No response from server");
            return rejectWithValue(error.message);
        }
    }
);

const NeighborInviteSearchSlice = createSlice({
    name: "neighborInviteSearch",
    initialState: {
        results: [],
        count: 0,
        next: null,
        previous: null,
        message: null,
        loading: false,
        loadingMore: false,
        error: null,
        currentPage: 1,
    },
    reducers: {
        resetInviteSearch(state) {
            state.results = [];
            state.count = 0;
            state.next = null;
            state.previous = null;
            state.message = null;
            state.loading = false;
            state.loadingMore = false;
            state.error = null;
            state.currentPage = 1;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchInviteNeighbors.pending, (state, action) => {
                const page = action.meta.arg?.page ?? 1;
                if (page === 1) {
                    state.loading = true;
                    state.results = [];
                } else {
                    state.loadingMore = true;
                }
                state.error = null;
                state.message = null;
            })
            .addCase(searchInviteNeighbors.fulfilled, (state, action) => {
                const { data, page } = action.payload;
                state.loading = false;
                state.loadingMore = false;
                state.count = data.count ?? 0;
                state.next = data.next ?? null;
                state.previous = data.previous ?? null;
                state.message = data.message ?? null;
                state.currentPage = page;
                if (page === 1) {
                    state.results = data.results ?? [];
                } else {
                    state.results = [...state.results, ...(data.results ?? [])];
                }
            })
            .addCase(searchInviteNeighbors.rejected, (state, action) => {
                state.loading = false;
                state.loadingMore = false;
                state.error = action.payload;
            });
    },
});

export const { resetInviteSearch } = NeighborInviteSearchSlice.actions;
export default NeighborInviteSearchSlice.reducer;
